import { getImageRoot } from 'src/helpers';

interface ThankYouData {
  images: { src: string; alt: string }[];
}

export const useThankYouData = (isSmallDesktop: boolean): ThankYouData => {
  const imageRoot = getImageRoot(isSmallDesktop);

  const images = [
    {
      src: `${imageRoot}/credits-interestform-typ-1.jpg`,
      alt: 'A truck driving on a road through a forest',
    },
    {
      src: `${imageRoot}/credits-interestform-typ-2.jpg`,
      alt: 'A direct air capture module',
    },
    {
      src: `${imageRoot}/credits-interestform-typ-3.jpg`,
      alt: 'Raindrops on a leaf',
    },
    ...(isSmallDesktop
      ? [
          {
            src: `${imageRoot}/credits-interestform-typ-4.jpg`,
            alt: 'An aerial view of a rainforest',
          },
        ]
      : []),
  ];

  return {
    images,
  };
};
